import moment from 'moment'

    export function getNoOfDaysFromCurrentDate(createddate) {

    try {
      var date1 = new Date(createddate);
    var date2 = new Date(moment(new Date()).format('MM/DD/YYYY'));

    var Difference_In_Time = date2.getTime() - date1.getTime();
    var Difference_In_Days = Difference_In_Time / (1000 * 3600 * 24);
      
    return Difference_In_Days;
    } catch (HTTPException) {
      console.log("Catch getNoOfDelayDays : " + HTTPException);
      return 0;
    }
  }


// WEBPACK FOOTER //
// ./src/services/DateCalcFuntion.js